export default __webpack_public_path__ + "static/media/475.60df339b.jpg";